import React from 'react';

/**
 * Retina image component that automatically generates a `srcSet` string based
 * on the given set of images in the `srcSet` array.
 */
export default (props) => {
  var { srcSet, ...props } = props;
  let srcSetComponents = srcSet.map((img, i) => `${img} ${i + 1}x`);
  return <img {...props} src={srcSet[0]} srcSet={srcSetComponents.join(',')} />;
};



// WEBPACK FOOTER //
// ./src/components/RetinaImage.js